import { Link } from 'react-router-dom';
import { ReactComponent as BgHero } from '../../../Assets/img/bg-hero-landing-prods.svg'

interface HeroProps {
    titulo: string;
    subTitulo?: string | { __html: string };
    url: string;
    icon: string;
    color?: string;
}

export const Hero = ({
    titulo,
    subTitulo,
    url,
    icon,
    color,
}: HeroProps) => {
    return (
        <div className="position-relative pt-40 py-lg-55 z-1 landing-white-circle">
            <div className="container">
                <div className="row align-items-lg-center">
                    <div className="col-10 col-md-8 col-lg-6 col-xl-4 mx-auto mx-lg-0 mb-30 mb-lg-0 text-center text-lg-start">
                        {/* h1: es el título principal de la landing. Las clases fs-* pisan el
                            font-size que Bootstrap le da al h1, así que el hero se ve igual. */}
                        <h1 className="ff-mukta fw-bold fs-30 fs-lg-50 lh-11 text-black mb-12 mb-lg-32">
                            {titulo}
                        </h1>
                        <p className="fs-16 fs-lg-20 lh-12 text-black mb-16 mb-lg-50">
                            {typeof subTitulo === 'string' ? (
                                subTitulo
                            ) : (
                                <span dangerouslySetInnerHTML={subTitulo} />
                            )}
                        </p>
                        {
                            url === "#formulario" ?
                                <a
                                    href={url}
                                    className={`transition-base d-inline-block w-180p w-lg-220p py-10 py-lg-14 rounded-2 fs-16 fs-lg-20 fw-bold lh-1 text-center text-white ${color ? "" : "bg-primary"}`}
                                    style={{ background: color }}
                                >
                                    Cotizá ahora
                                </a>
                                :
                                <Link
                                    to={url}
                                    className={`transition-base d-inline-block w-180p w-lg-220p py-10 py-lg-14 rounded-2 fs-16 fs-lg-20 fw-bold lh-1 text-center text-white ${color ? "" : "bg-primary"}`}
                                    style={{ background: color }}
                                >
                                    Cotizá ahora
                                </Link>
                        }

                    </div>
                    <div className="col-lg-6 ms-auto">
                        <div className="position-relative w-128p w-lg-360p mx-auto mb-n5 mb-lg-0">
                            <div className={!color ? "text-primary" : ""} style={{ color }}>
                                <BgHero width="100%" height="100%" />
                            </div>
                            <div className="position-absolute d-flex start-0 end-0 top-0 bottom-0 justify-content-center align-items-center text-white">
                                <svg className="svg-icon" width="45%" height="45%">
                                    <use xlinkHref={icon} />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}